import { render, staticRenderFns } from "./RequiredItem.vue?vue&type=template&id=1f9ed473&scoped=true&"
import script from "./RequiredItem.vue?vue&type=script&lang=js&"
export * from "./RequiredItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9ed473",
  null
  
)

export default component.exports